import { render, staticRenderFns } from "./ItemKakao.vue?vue&type=template&id=73264f9c&scoped=true&"
import script from "./ItemKakao.vue?vue&type=script&lang=js&"
export * from "./ItemKakao.vue?vue&type=script&lang=js&"
import style0 from "./ItemKakao.vue?vue&type=style&index=0&id=73264f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73264f9c",
  null
  
)

export default component.exports